import { useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Alert from "@material-ui/lab/Alert";
import moment from "moment";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import { DatePicker } from "@material-ui/pickers";
import { FormattedMessage } from "react-intl";

import { BusinessOwnerService } from "../../../../services/BusinessOwnerService";
import { ActivityItem } from "../../../../components/activity_item/ActivityItem";
import { YYYY_MM_DD_FORMAT } from "../../../../settings/constants";

interface ActivityTabProps {
  business: number;
}

const useStyles = makeStyles(() => ({
  main: {
    minHeight: "75vh",
    overflow: "hidden",
    width: "100%",
    flexGrow: 1,
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 20,
    paddingBottom: 20,
  },
}));

export const ActivityTab = (props: ActivityTabProps) => {
  const classes = useStyles();
  const { business } = props;
  const [activities, setActivities] = useState([]);
  const [currentDate, setCurrentDate] = useState(moment());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    async function loadActivities() {
      setLoading(true);
      setError(false);
      try {
        const activitiesResult = await BusinessOwnerService.getActivities({
          businessId: business,
          date: currentDate.format(YYYY_MM_DD_FORMAT),
        });
        if (activitiesResult.isSuccess && activitiesResult.data.code === 100) {
          const responseData = JSON.parse(
            JSON.stringify(activitiesResult.data.data)
          );
          let activities = responseData.activities;
          setActivities(activities);
        } else {
          setError(true);
        }
      } catch (_) {
        setError(true);
      }
      setLoading(false);
    }
    loadActivities();
  }, [currentDate, business]);

  return (
    <Paper className={classes.main} elevation={3}>
      <Grid container spacing={1}>
        <Grid xs={12} sm={12} lg={12}>
          {loading && <CircularProgress />}
          {error && (
            <Alert
              severity="error"
              action={
                <Button
                  onClick={() => setCurrentDate(moment())}
                  color="inherit"
                  size="small"
                >
                  <FormattedMessage id="sharedScreen.loadAgain" />
                </Button>
              }
            >
              <FormattedMessage id="sharedScreen.thereWasAProblemLoadingDatas" />
            </Alert>
          )}
        </Grid>
        <Grid xs={12} sm={12} lg={12} container justify="flex-end">
          <DatePicker
            views={["year", "month"]}
            maxDate={new Date()}
            value={currentDate}
            onChange={setCurrentDate}
          />
        </Grid>
        {activities.map((entry) => (
          <ActivityItem date={entry.date} activities={entry.activities} />
        ))}
      </Grid>
    </Paper>
  );
};

export default ActivityTab;
